// Generated by CoffeeScript 2.4.1
(function() {
  var Weaver, WeaverModelClass, _,
    indexOf = [].indexOf;

  Weaver = require('./Weaver');

  _ = require('lodash');

  // These have context
  // modelClass.definition
  // modelClass.classDefinition
  // modelClass.totalClassDefinition

  // This class should act on maps that are set during init
  WeaverModelClass = class WeaverModelClass extends Weaver.Node {
    static classId() {
      return `${this.definition.name}:${this.className}`;
    }

    // Make a node member of this class
    static addMember(node) {
      if (node instanceof WeaverModelClass) {
        return node.nodeRelation(this.model.definition.member).addInGraph(this.getNode(), node.getGraph());
      } else {
        return node.relation(this.model.definition.member).addInGraph(this.getNode(), node.getGraph());
      }
    }

    // Construct a node representing this ModelClass
    static getNode() {
      return Weaver.Node.getFromGraph(this.classId(), this.context.getGraph());
    }

    static isAllowedAttribute(key) {
      var ref;
      return ((ref = this.totalClassDefinition.attributes) != null ? ref[key] : void 0) != null;
    }

    static isAllowedRelation(key) {
      var ref;
      return ((ref = this.totalClassDefinition.relations) != null ? ref[key] : void 0) != null;
    }

    static allSubClasses() {
      var subClassId;
      return _.union(...((function() {
        var i, len, ref, results;
        ref = this.subClasses;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          subClassId = ref[i];
          results.push(this.model.classList[subClassId].allSubClasses());
        }
        return results;
      }).call(this)), this.subClasses);
    }

    constructor(nodeId = Weaver.Node.generateId(), graph, model) {
      var classNode;
      super(nodeId, graph);
      this.model = model;
      this.context = this.constructor.context;
      // Add type definition to model class
      classNode = Weaver.Node.getFromGraph(this.constructor.classId(), this.context.getGraph());
      this.nodeRelation(this.model.getMemberKey()).addInGraph(classNode, this.graph);
    }

    static getSuperClasses() {
      var base, ref, superC;
      if (((ref = this.classDefinition) != null ? ref.super : void 0) != null) {
        // TODO: probably won't work for (n isDeeperThan 2)-dot-referenced models
        superC = (base = this.classDefinition.super.split('.'))[1] != null ? base[1] : base[1] = this.classDefinition.super;
        return [this.model[superC]].concat(this.model[superC].getSuperClasses());
      } else {
        return [];
      }
    }

    static allAttributes() {
      var definition, key, ref, results;
      ref = this.totalClassDefinition.attributes;
      results = [];
      for (key in ref) {
        definition = ref[key];
        results.push(definition);
      }
      return results;
    }

    static allRelations() {
      var definition, key, ref, results;
      ref = this.totalClassDefinition.relations;
      results = [];
      for (key in ref) {
        definition = ref[key];
        results.push(definition);
      }
      return results;
    }

    getInherit() {
      return this.nodeRelation(this.model.getInheritKey()).all();
    }

    getInheritKey() {
      console.warn('Deprecated function WeaverModelClass.getInheritKey() used. Ask the model, not this modelclass.');
      return this.model.getInheritKey();
    }

    getMember() {
      return this.nodeRelation(this.model.getMemberKey()).all();
    }

    getPrototype() {
      console.warn('Deprecated function WeaverModelClass.getPrototype() used. Use WeaverModelClass.getMember().');
      return this.getMember();
    }

    // override
    _loadRelationFromQuery(key, instance, relId, graph, created, creator) {
      var mappedKey, params, typeIds, typeNode;
      mappedKey = key;
      // Look up the model key based on the db key
      if (instance instanceof Weaver.ModelClass) {
        typeIds = (function() {
          var i, len, ref, results;
          ref = instance.getMember();
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            typeNode = ref[i];
            results.push(typeNode.id());
          }
          return results;
        })();
        mappedKey = this._getModelKey(key, typeIds[0]) || key;
      }
      params = {
        node: new Weaver.Node(relId, graph),
        addToPendingWrites: false,
        created,
        creator
      };
      if (this.totalClassDefinition.relations[mappedKey] != null) {
        return this.relation(mappedKey).add(instance, params);
      } else {
        return this.nodeRelation(mappedKey).add(instance, params);
      }
    }

    // override
    _loadRelationInFromQuery(key, instance, relId, graph, created, creator) {
      var mappedKey, params, typeIds, typeNode;
      mappedKey = key;
      // Look up the model key based on the db key
      if (instance instanceof Weaver.ModelClass) {
        typeIds = (function() {
          var i, len, ref, results;
          ref = instance.getMember();
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            typeNode = ref[i];
            results.push(typeNode.id());
          }
          return results;
        })();
        mappedKey = this._getModelKey(key, typeIds[0]) || key;
      }
      params = {
        node: new Weaver.Node(relId, graph),
        addToPendingWrites: false,
        created,
        creator
      };
      if (this.totalClassDefinition.relations[mappedKey] != null) {
        return this.relationIn(mappedKey).addIn(instance, params);
      } else {
        return this.nodeRelationIn(mappedKey).addIn(instance, params);
      }
    }

    _getAttributeKey(field) {
      var ref;
      if (this.totalClassDefinition.attributes == null) {
        throw new Error(`For ${this.id()} of class ${this.className} model is not allowed to have attributes`);
      }
      if (indexOf.call(Object.keys(this.totalClassDefinition.attributes), field) < 0) {
        throw new Error(`${this.className} model is not allowed to have the ${field} attribute`);
      }
      return ((ref = this.totalClassDefinition.attributes[field]) != null ? ref.key : void 0) || field;
    }

    _getAttributeKeyDataType(field) {
      var ref;
      if (this.totalClassDefinition.attributes == null) {
        throw new Error(`${this.className} model is not allowed to have attributes`);
      }
      if (indexOf.call(Object.keys(this.totalClassDefinition.attributes), field) < 0) {
        throw new Error(`${this.className} model is not allowed to have the ${field} attribute`);
      }
      return ((ref = this.totalClassDefinition.attributes[field]) != null ? ref.datatype : void 0) || void 0; // todo: change datatype field in model to dataType
    }

    _getRelationKey(key) {
      if (key === this.model.getInheritKey()) {
        return key;
      }
      if (key === this.model.getMemberKey()) {
        return key;
      }
      if (!this.constructor.isAllowedRelation(key)) {
        throw new Error(`${this.className} model is not allowed to have the ${key} relation`);
      }
      return this.totalClassDefinition.relations[key].key || key;
    }

    _getModelKeyPerRange(relationKey) {
      var i, len, map, modelKey, range, ref, ref1, relDef;
      map = {};
      ref = this.totalClassDefinition.relations;
      for (modelKey in ref) {
        relDef = ref[modelKey];
        if (relDef != null) {
          if (((relDef.key == null) && modelKey === relationKey) || (relDef.key === relationKey)) {
            ref1 = relDef.range || [];
            for (i = 0, len = ref1.length; i < len; i++) {
              range = ref1[i];
              if (map[range] == null) {
                map[range] = [];
              }
              map[range].push(modelKey);
            }
          }
        }
      }
      return map;
    }

    // throws an exception if the number of matches found is greater than 1
    // returns undefined if no match is found
    _getModelKey(relationKey, ...toClassIds) {
      var i, key, keyMatches, len, map, toClassId;
      map = this._getModelKeyPerRange(relationKey);
      keyMatches = [];
      for (i = 0, len = toClassIds.length; i < len; i++) {
        toClassId = toClassIds[i];
        if (map[toClassId] != null) {
          if (map[toClassId].length > 1) {
            throw new Error(`${this.className} model has multiple modelKeys for a relation to a node of type ${toClassId}`);
          }
          key = map[toClassId][0];
          if (indexOf.call(keyMatches, key) < 0) {
            keyMatches.push(key);
          }
        }
      }
      if (keyMatches.length > 1) {
        throw new Error(`Finding a modelKey for ${this.className} with relationKey ${relationKey} for defs ${JSON.stringify(toClassIds)} faild because mutlipe options where found: ${JSON.stringify(keyMatches)}`);
      }
      return keyMatches[0];
    }

    static getRanges(key) {
      return this.totalRangesMap[key] || [];
    }

    getRanges(key) {
      return this.totalRangesMap[key] || [];
    }

    getDefinitions() {
      var def, defs;
      defs = (function() {
        var i, len, ref, results;
        ref = this.nodeRelation(this.model.getMemberKey()).all();
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          def = ref[i];
          results.push(def.id());
        }
        return results;
      }).call(this);
      defs = this.model.addSupers(defs);
      return defs;
    }

    getToRanges(key, to) {
      var def, defs, i, len, ranges, results;
      if (to instanceof Weaver.ModelClass || to instanceof Weaver.DefinedNode) {
        defs = to.getDefinitions();
        ranges = this.getRanges(key);
        results = [];
        for (i = 0, len = defs.length; i < len; i++) {
          def = defs[i];
          if (indexOf.call(ranges, def) >= 0) {
            results.push(def);
          }
        }
        return results;
      } else {
        return [];
      }
    }

    attributes() {
      var attributes, definiton, key, ref;
      if (this.totalClassDefinition.attributes == null) {
        return {};
      }
      attributes = {};
      ref = this.totalClassDefinition.attributes;
      for (key in ref) {
        definiton = ref[key];
        attributes[key] = this.get(key);
      }
      return attributes;
    }

    relations() {
      var definiton, key, ref, relations;
      if (this.totalClassDefinition.relations == null) {
        return {};
      }
      relations = {};
      ref = this.totalClassDefinition.relations;
      for (key in ref) {
        definiton = ref[key];
        relations[key] = this.relation(key);
      }
      return relations;
    }

    nodeGet(...args) {
      return Weaver.Node.prototype.get.call(this, ...args);
    }

    get(field) {
      var e, mappedKey, value;
      try {
        mappedKey = this._getAttributeKey(field);
        value = super.get(mappedKey);
        return value;
      } catch (error) {
        e = error;
        console.error(e);
        return void 0;
      }
    }

    getLabel() {
      var label;
      if (this.totalClassDefinition.label != null) {
        label = this.get(this.totalClassDefinition.label);
      }
      return label || this.id();
    }

    nodeSet(...args) {
      return Weaver.Node.prototype.set.call(this, ...args);
    }

    set(key, value, params = {}) {
      params.dataType = this._getAttributeKeyDataType(key);
      key = this._getAttributeKey(key);
      if (key == null) {
        return null;
      }
      return super.set(key, value, params);
    }

    unset(field, value) {
      var key;
      key = this._getAttributeKey(field);
      if (key == null) {
        return null;
      }
      return super.unset(key);
    }

    nodeRelation(...args) {
      return Weaver.Node.prototype.relation.call(this, ...args);
    }

    nodeRelationIn(...args) {
      return Weaver.Node.prototype.relationIn.call(this, ...args);
    }

    relation(key) {
      var className, classRelation, definition, model, modelKey, relationDefinition, relationKey;
      modelKey = key;
      relationKey = this._getRelationKey(key);
      model = this.model;
      className = this.className;
      definition = this.definition;
      relationDefinition = this.totalClassDefinition.relations[key];
      classRelation = class extends Weaver.ModelRelation {
        constructor(owner, key) {
          super(owner, key);
          this.modelKey = modelKey;
          this.relationKey = relationKey;
          this.model = model;
          this.className = className;
          this.definition = definition;
          this.relationDefinition = relationDefinition;
        }

      };
      return super.relation(relationKey, classRelation);
    }

    save(project) {
      var attribute, current, key, max, min, ref, ref1, relation;
      ref = this.totalClassDefinition.attributes;
      // Check required attributes
      for (key in ref) {
        attribute = ref[key];
        if (attribute != null ? attribute.required : void 0) {
          if (this.get(key) == null) {
            console.warn(`Attribute ${key} is required for a ${this.className} model`);
          }
        }
      }
      ref1 = this.totalClassDefinition.relations;
      // Check cardinality on relations
      for (key in ref1) {
        relation = ref1[key];
        if (!((relation != null ? relation.card : void 0) != null)) {
          continue;
        }
        [min, max] = relation.card;
        current = this.relation(key).all().length;
        if (current < min) {
          console.warn(`Relation ${key} requires a minimum of ${min} relations for a ${this.className} model. Currently ${current} is set.`);
        } else if (max !== 'n' && current > max) {
          console.warn(`Relation ${key} allows a maximum of ${max} relations for a ${this.className} model. Currently ${current} is set.`);
        }
      }
      return super.save(project);
    }

  };

  module.exports = WeaverModelClass;

}).call(this);
